import type { JSX } from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.css';

interface IBackdrop {
  onClose: () => void;
  visible: boolean;
}
interface IModalOverlay {
  children: JSX.Element | JSX.Element[];
  visible: boolean;
}

interface IModal extends IBackdrop, IModalOverlay {
  visible: boolean;
}
const Backdrop = ({ onClose, visible }: IBackdrop) => {
  return (
    <div
      data-testid="modalBackdropDivTestId"
      className={`${styles.backdrop} ${visible ? styles.show : styles.hide}`}
      onClick={onClose}
    />
  );
};
const ModalOverlay = ({ children, visible }: IModalOverlay) => {
  return (
    <div
      data-testid="modalOverlyDivTestId"
      className={`${styles.modal} ${visible ? styles.show : styles.hide}`}>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

let portalElement = document.getElementById('overlays') as HTMLElement;

if (!portalElement) {
  portalElement = document.createElement('div');
  portalElement.setAttribute('id', 'overlays');
  document.body.appendChild(portalElement);
}

const Modal = ({ onClose, children, visible }: IModal) => {
  return (
    <>
      {ReactDOM.createPortal(<Backdrop onClose={onClose} visible={visible} />, portalElement)}
      {ReactDOM.createPortal(
        <ModalOverlay visible={visible}>{children}</ModalOverlay>,
        portalElement
      )}
    </>
  );
};

export default Modal;
